<ng-template #noPermission><boma-unauthed></boma-unauthed></ng-template>
<ng-container
  *permissionChecker="
    { permissions: ['view-entity-roles'], requirement: 'all' };
    else noPermission
  "
>
  <h3>Entity Roles</h3>
  <boma-crud-table
    (createSubmit)="onCreateSubmit()"
    (itemDeleted)="onItemDeleted($event)"
    (updateSelection)="handleUpdateSelection($event)"
    (updateSubmit)="onUpdateSubmit()"
    (viewSelection)="handleUpdateSelection($event)"
    [allowDelete]="false"
    [createFormTemplateReference]="createFormTemplate"
    [createFormValid]="createFormGroup.valid"
    [data]="roles$ | async"
    [headersValue]="'Roles'"
    [loaded]="loaded$ | async"
    [selectableColumns]="columns"
    [singularTerm]="'Role'"
    [updateFormTemplateReference]="updateFormTemplate"
    [viewFormTemplateReference]="viewFormTemplate"
    [viewable]="true"
  >
  </boma-crud-table>

  <h3>Boma Preset Roles</h3>

  <boma-crud-table
    (viewSelection)="handleUpdateSelection($event)"
    [allowDelete]="false"
    [data]="presetRoles$ | async"
    [headersValue]="'Preset Roles'"
    [loaded]="loaded$ | async"
    [selectableColumns]="columns"
    [singularTerm]="'Preset Role'"
    [viewFormTemplateReference]="viewFormTemplate"
    [viewable]="true"
  >
  </boma-crud-table>

  <ng-template #viewFormTemplate>
    <form [formGroup]="updateFormGroup" class="grid formgrid">
      <div class="field col-12">
        <label> Name: </label>
        <input formControlName="name" pInputText required type="text" />
      </div>
      <div class="field col-12">
        <label> Description </label>
        <textarea
          cols="30"
          formControlName="description"
          id="desc"
          name=""
          pInputText
          rows="10"
        ></textarea>
      </div>

      <div
        *ngIf="rolesFacade.selectedRoles$ | async as role"
        class="field col-12"
      >
        <div *ngFor="let permission of role.permissions">
          {{ permission }}
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #createFormTemplate>
    <ng-container
      *permissionChecker="
        { permissions: ['add-entity-roles'], requirement: 'all' };
        else noPermission
      "
    >
      <form [formGroup]="createFormGroup" class="formgrid grid">
        <div class="field col-12 md:col-6">
          <label for="name"> Name: </label>
          <input
            id="name"
            formControlName="name"
            pInputText
            required
            type="text"
            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          />
        </div>
        <div class="field col-12 md:col-6">
          <label> Target: </label>
          <span class="p-fluid">
            <p-multiSelect [options]="targetTypes" formControlName="target">
            </p-multiSelect>
          </span>
        </div>

        <div class="field col-12">
          <label> Description </label>
          <textarea
            formControlName="description"
            pInputText
            rows="2"
            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          ></textarea>
        </div>

        <div
          *ngIf="permissionsFacade.permissions$ | async as permissions"
          class="field col-12"
        >
          <p-listbox
            [filter]="true"
            [checkbox]="true"
            [multiple]="true"
            [options]="permissions.entity"
            formControlName="permissions"
            [listStyle]="{ 'max-height': '250px' }"
          >
          </p-listbox>
        </div>
      </form>

      <p-messages severity="info">
        <ng-template pTemplate>
          <span class="custom-message"
            >Remember roles are assigned from the user module.</span
          >
        </ng-template>
      </p-messages>
    </ng-container>
  </ng-template>

  <ng-template #updateFormTemplate>
    <ng-container
      *permissionChecker="
        { permissions: ['edit-entity-roles'], requirement: 'all' };
        else noPermission
      "
    >
      <form [formGroup]="updateFormGroup" class="formgrid grid">
        <div class="field col-12">
          <label> Name: </label>
          <input
            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            formControlName="name"
            pInputText
            required
            type="text"
          />
        </div>
        <div class="field col-12">
          <label> Description </label>
          <textarea
            formControlName="description"
            id="desc"
            name=""
            pInputText
            rows="2"
            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          ></textarea>
        </div>
        <div class="field col-12">
          <label> Target: </label>
          <span class="p-fluid">
            <p-multiSelect [options]="targetTypes" formControlName="target">
            </p-multiSelect>
          </span>
        </div>
        <div
          *ngIf="permissionsFacade.permissions$ | async as permissions"
          class="field col-12"
        >
          <p-listbox
            [filter]="true"
            [checkbox]="true"
            [multiple]="true"
            [options]="permissions.entity"
            formControlName="permissions"
            [listStyle]="{ 'max-height': '250px' }"
          >
          </p-listbox>
        </div>
      </form>
    </ng-container>
  </ng-template>
</ng-container>

<ng-template #noPermission><boma-unauthed></boma-unauthed></ng-template>
